import { PaytronixGiftAuthSource } from './paytronix_gift_auth_source.js';

export function name(authSource: PaytronixGiftAuthSource): string {
  switch (authSource) {
    case PaytronixGiftAuthSource.Direct:
      return 'Paytronix Gift Card Direct';
    case PaytronixGiftAuthSource.Olo:
      return 'Paytronix Olo';
  }
}
